export default function CareerCard({ jobTitle, jobDescription, facebookLink, datePosted }) {
    return (
        <div className="max-w-md overflow-hidden rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0c0c0c] shadow-2xl shadow-black/40 transition duration-500 hover:-translate-y-1 hover:border-zinc-500">
            {/* Gold line at the top */}
            <div className="h-px bg-gradient-to-r from-transparent via-zinc-200 to-transparent"></div>

            <div className="p-8">
                <h3 className="mb-3 font-fontMontserrat text-3xl text-zinc-100">{jobTitle}</h3>
                <p className="mb-6 leading-7 text-zinc-400">{jobDescription}</p>
                <p className="mb-6 font-mono text-xs tracking-[0.08em] text-zinc-500">Posted on: {datePosted}</p>
                <a
                    href={facebookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block border-b border-zinc-500 pb-1 text-sm font-medium tracking-[0.12em] text-zinc-200 transition hover:border-white hover:text-white"
                >
                    Read More →
                </a>
            </div>
        </div>
    );
}
